// customToast.js
import { toast, ToastContent } from "react-toastify";

export const customToast = {
    success(msg: ToastContent, options = {}) {
        return toast.success(msg, {
            ...options,
            className: "toast-container toast-success-container",
        });
    },
    error(msg: ToastContent, options = {}) {
        return toast.error(msg, {
            ...options,
            className: "toast-container toast-error-container",
        });
    },
    info(msg: ToastContent, options = {}) {
        return toast.info(msg, {
            ...options,
            className: "toast-container toast-info-container",
        });
    }
};
